export default {
    created: "Logul opt-in WhatsApp a fost creat cu succes.",
    updated: "Logul opt-in WhatsApp a fost actualizat cu succes.",
    deleted: "Logul opt-in WhatsApp a fost sters cu succes.",
    restored: "Logul opt-in WhatsApp a fost restaurat cu succes.",
}
